if (!customElements.get('dabov-image-slideshow')) {
  customElements.define(
    'dabov-image-slideshow',
    class DabovImageSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-dabov-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dabov-slide-dot]'));
        this.currentIndex = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active')),
        );

        this.onPrevious = () => this.show(this.currentIndex - 1, true);
        this.onNext = () => this.show(this.currentIndex + 1, true);
        this.onVisibilityChange = () => (document.hidden ? this.stop() : this.start());
        this.onBlockSelect = (event) => {
          const selectedSlide = event.target.closest('[data-dabov-slide]');
          if (!selectedSlide || !this.contains(selectedSlide)) return;
          this.stop();
          this.show(this.slides.indexOf(selectedSlide));
        };

        this.querySelector('[data-dabov-previous]')?.addEventListener('click', this.onPrevious);
        this.querySelector('[data-dabov-next]')?.addEventListener('click', this.onNext);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        if (this.dataset.pauseOnHover === 'true') {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
        }

        this.show(this.currentIndex);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      show(index, restart = false) {
        if (!this.slides?.length) return;
        const total = this.slides.length;
        this.currentIndex = (index + total) % total;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
        });

        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === this.currentIndex ? 'true' : 'false');
        });

        const current = this.querySelector('[data-dabov-current]');
        if (current) current.textContent = String(this.currentIndex + 1);

        if (restart) {
          this.stop();
          this.start();
        }
      }

      start() {
        if (
          this.timer ||
          this.slides?.length < 2 ||
          this.dataset.autoplay !== 'true' ||
          document.hidden ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
          window.Shopify?.designMode
        ) {
          return;
        }

        const interval = Math.max(2, Number(this.dataset.interval || 5)) * 1000;
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = undefined;
      }
    },
  );
}
